<div mat-dialog-content>
    <p>{{data.body}}</p>
    <button mat-button color="primary" (click)="close()">{{ 'close' | translate}}</button>
</div>